'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (
          !desc ||
          ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)
        ) {
          desc = {
            enumerable: true,
            get: function () {
              return m[k];
            },
          };
        }
        Object.defineProperty(o, k2, desc);
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', { enumerable: true, value: v });
      }
    : function (o, v) {
        o['default'] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = __importStar(require('react'));
const styled_1 = __importDefault(require('@emotion/styled'));
const Button = styled_1.default.button``;
function SubmitBtn(_a) {
  var {
      btnText = 'Submit',
      errorText = 'Submit',
      isError = false,
      isPending = false,
      isSuccess = false,
      pendingText = 'Sending...',
      successText = 'Success',
    } = _a,
    extraProps = __rest(_a, [
      'btnText',
      'errorText',
      'isError',
      'isPending',
      'isSuccess',
      'pendingText',
      'successText',
    ]);
  const [buttonText, setButtonText] = (0, react_1.useState)(btnText);
  const [disabled, setDisabled] = (0, react_1.useState)(false);
  const [buttonState, setButtonState] = (0, react_1.useState)('WAITING');
  (0, react_1.useEffect)(() => {
    if (isPending) {
      setButtonText(pendingText);
      setDisabled(true);
    } else {
      setButtonText(btnText);
      setDisabled(false);
    }
  }, [isPending]);
  (0, react_1.useEffect)(() => {
    if (isSuccess) {
      setButtonText(successText);
      setDisabled(false);
    } else {
      setDisabled(false);
    }
  }, [isSuccess]);
  (0, react_1.useEffect)(() => {
    if (isError) {
      setButtonText(errorText);
      setDisabled(false);
    } else {
      setDisabled(false);
    }
  }, [isError]);
  (0, react_1.useEffect)(() => {
    if (isPending) {
      setButtonState('PENDING');
    } else if (isSuccess) {
      setButtonState('SUCCESS');
    } else if (isError) {
      setButtonState('ERROR');
    } else {
      setButtonState('WAITING');
    }
  }, [isSuccess, isPending]);
  return react_1.default.createElement(
    Button,
    Object.assign(
      { disabled: disabled, state: buttonState, type: 'submit' },
      extraProps
    ),
    buttonText
  );
}
exports.default = SubmitBtn;
//# sourceMappingURL=SubmitBtn.js.map
